import { i18n as _i18n } from "@lingui/core";
import { FieldErrorMessage } from '@wkda/funnel-components';
import cx from 'classnames';
import { useLocation } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
const LICENSE_PLATE_NOT_RECOGNIZED_PARAM = 'licensePlateNotRecognized';
export function CarleadLicensePlateNotRecognized(_ref) {
  let {
    message = _i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.licensePlate.wrongLicensePlate',
      message: "Unfortunately, we cannot find your registration number"
    }),
    className
  } = _ref;
  const {
    search
  } = useLocation();
  return search.includes(LICENSE_PLATE_NOT_RECOGNIZED_PARAM) ? /*#__PURE__*/_jsx(FieldErrorMessage, {
    className: cx('license-plate-not-recognized', className),
    children: message
  }) : null;
}